var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83317 18.3346V9.16797M1.6665 10.8346V16.668C1.6665 17.5884 2.4127 18.3346 3.33317 18.3346H14.5217C15.7556 18.3346 16.805 17.4344 16.9926 16.2148L17.8901 10.3814C18.1231 8.86705 16.9514 7.5013 15.4191 7.5013H12.4998C12.0396 7.5013 11.6665 7.12821 11.6665 6.66797V3.72283C11.6665 2.58796 10.7465 1.66797 9.61164 1.66797C9.34095 1.66797 9.09565 1.82738 8.98572 2.07474L6.05312 8.67308C5.91937 8.97402 5.62093 9.16797 5.29161 9.16797H3.33317C2.4127 9.16797 1.6665 9.91416 1.6665 10.8346Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/thumbs-up.bd625bea0a54191f3afbd7e083877361.svg";
export { ForwardRef as ReactComponent };